import React, { createContext } from "react";
import { QueryParams } from "../../../services/data/dashboard";

export type DataBoardDefault = {
  // 上级标签页索引值
  mainTabIndex: string
  tabIndex: string
  projectId: number
  projectCode: string
  queryParams: QueryParams
  tableScrollY: number
}

export const defaultValue: DataBoardDefault = {
  mainTabIndex: '0',
  tabIndex: '2',
  projectId: 0,
  projectCode: '',
  queryParams: {},
  tableScrollY: 200
}

export const DataBoardContext = createContext<DataBoardDefault>({
  ...defaultValue
})